import { render } from "./Template5View.vue?vue&type=template&id=49e4fd02"
import script from "./Template5View.vue?vue&type=script&lang=js"
export * from "./Template5View.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__